// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".oldTargetPriceClass[data-v-05abb7c4]{background-color:#fff;border:thin solid rgba(0,0,0,.1)!important;color:#101828}.old-target-price-strike[data-v-05abb7c4]{-webkit-text-decoration:line-through!important;text-decoration:line-through!important;text-decoration-color:#d32f2f!important;text-decoration-thickness:1px!important}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
